export default {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    back: 'Back',
    signOut: 'Sign Out',
    actions: 'Actions',
    search: 'Search',
    searching: 'Searching...',
    select: 'Select...',
    useMyLocation: 'Use My Location',
    locating: 'Locating...',
    pickFromMap: 'Pick Location from Map',
    hideMap: 'Hide Map',
    allItemsLoaded: 'All items loaded',
    operatorLocations: 'Locations by operator',
    searchResults: 'Found {{count}} locations matching "{{term}}"',
    loadMore: 'Load More',
    optional: 'Optional',
  },
  auth: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    currency: 'Currency',
    darkMode: 'Dark Mode',
    notifications: {
      title: "Notification Settings",
      firebase: 'Firebase',
      fcmServerKey: "Firebase Cloud Messaging Server Key",
      fcmServerKeyPlaceholder: "Enter your FCM server key",
      fcmServerKeyHelp: "Required for sending push notifications to Android devices",
      apple: 'Apple',
      apnsKeyId: "Apple Push Notification Key ID",
      apnsKeyIdPlaceholder: "Enter your APNs Key ID",
      apnsTeamId: "Apple Developer Team ID",
      apnsTeamIdPlaceholder: "Enter your Apple Developer Team ID",
      apnsBundleId: "Apple App Bundle ID",
      apnsBundleIdPlaceholder: "com.yourcompany.app",
      apnsProduction: "Use APNs Production Environment",
      testNotification: "Send Test Notification"
    },
    paymentGateways: 'Payment Gateways',
    adminSettings: 'Admin Settings',
    operatorSettings: 'Operator Settings',
    paymentGatewayInheritMessage: 'You are currently using the admin\'s payment gateway settings. Configure your own gateways below to override them.',
    paymentGatewayOverrideHint: 'Enter your value to override admin settings',
    mapsPlatform: {
      title: 'Maps Platform',
      description: 'Configure your preferred maps platform for location selection.',
      google: {
        title: 'Google Maps',
        apiKey: 'Google Maps API Key',
        enabled: 'Use Google Maps'
      },
      mapbox: {
        title: 'Mapbox',
        apiKey: 'Mapbox Access Token',
        enabled: 'Use Mapbox'
      }
    },
    publicCharging: {
      title: 'Public Charging',
      description: 'Allow users to add locations',
      allowUserAddLocation: 'Allow User to Add Location',
      allowUserAddLocationDescription: 'Allow users to add locations to the map',
      allowUserAddLocationError: 'Failed to update public charging location settings',
      allowUserAddLocationSuccess: 'Public charging location settings updated successfully',
    },
    objectStorage: {
      title: 'Object Storage Settings',
      enabled: 'Enable Object Storage',
      enabledDescription: 'Store uploaded files in S3-compatible storage instead of local server',
      provider: 'Storage Provider',
      providerDescription: 'Select the storage provider to use',
      endpoint: 'Endpoint URL',
      endpointDescription: 'S3 endpoint URL (e.g., https://s3.amazonaws.com)',
      bucket: 'Bucket Name',
      bucketDescription: 'Name of the S3 bucket to store files',
      accessKey: 'Access Key',
      accessKeyDescription: 'AWS access key or equivalent',
      secretKey: 'Secret Key',
      secretKeyDescription: 'AWS secret key or equivalent',
      cdnUrl: 'CDN URL',
      cdnUrlDescription: 'Optional CDN URL for serving files (e.g., https://cdn.example.com)',
      region: 'Region',
      regionDescription: 'AWS region or equivalent (e.g., us-east-1)',
      
    }
  },
  payment: {
    momo: 'Momo',
    vnpay: 'VNPay',
    zalopay: 'ZaloPay',
    partnerCode: 'Partner Code',
    accessKey: 'Access Key',
    secretKey: 'Secret Key',
    tmnCode: 'TMN Code',
    hashSecret: 'Hash Secret',
    appId: 'App ID',
    key1: 'Key 1',
    key2: 'Key 2',
    environment: {
      label: 'Environment',
      development: 'Development',
      production: 'Production'
    }
  },
  locations: {
    title: 'Locations',
    addLocation: 'Add Location',
    editLocation: 'Edit Location',
    name: 'Name',
    mapLocation: 'Map Location',
    selectOrManualEdit: 'Select or Manual Edit',
    address: 'Address',
    ward: 'Ward',
    district: 'District',
    city: 'City/District',
    country: 'Country',
    coordinates: 'Coordinates',
    status: 'Status',
    operator: 'Operator',
    locationName: 'Location Name',
    streetAddress: 'Street Address',
    stateProvince: 'State/Province',
    postalCode: 'Postal Code',
    latitude: 'Latitude',
    longitude: 'Longitude',
    workingHours: {
      title: 'Working Hours',
      openingTime: 'Opening Time',
      closingTime: 'Closing Time'
    },
    contact: {
      title: 'Contact Information',
      phone: 'Phone Number',
      website: 'Website'
    },
    amenities: {
      title: 'Amenities',
      waitingRoom: 'Waiting Room',
      parking: 'Parking',
      restroom: 'Restroom',
      wifi: 'WiFi',
      drinks: 'Drinks',
      food: 'Food',
      park: 'Park',
      restaurant: 'Restaurant',
      shoppingMall: 'Shopping Mall'
    },
    images: {
      title: 'Images',
      maxLimit: 'Max 6',
      addUrls: 'Or add image URLs (One per line)',
      preview: 'Location',
      remove: 'Remove image',
      confirmRemove: 'Are you sure you want to remove this image?',
    },
    locationStatus: {
      active: 'Active',
      inactive: 'Inactive',
      maintenance: 'Maintenance',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',      
    },
    confirmApprove: 'Are you sure you want to approve this location?',
    confirmReject: 'Are you sure you want to reject this location?',
    confirmDelete: 'Are you sure you want to delete this location?',
    cannotDelete: 'Can not delete this location',
    map: {
      search: 'Search for a location',
      useMyLocation: 'Use My Location',
      locating: 'Locating...',
      pickFromMap: 'Pick Location from Map',
      hideMap: 'Hide Map',
      country: 'Country',
      province: 'Province',
      district: 'District',
      ward: 'Ward',
      street: 'Street',
      streetPlaceholder: 'Enter street address'
    },
    search: 'Search for a location',
    allStatuses: 'All Statuses',
    allOperators: 'All Operators' ,  
  },
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    passwordMismatch: 'Passwords do not match',
    minLength: 'Must be at least {{count}} characters',
    maxLength: 'Must be at most {{count}} characters',
  },
  dashboard: {
    title: 'Dashboard',
    operators: 'Operators',
    chargePoints: 'Charge Points',
    settings: 'Settings',
    navigation: {
      dashboard: 'Dashboard',
      operators: 'Operators',
      chargePoints: 'Charge Points',
      settings: 'Settings',
      users: 'Users',
      transactions: 'Transactions',
      rfidTags: 'RFID Tags',
    },
    stats: {
      totalOperators: 'Total Operators',
      totalLocations: 'Total Locations',
      totalChargePoints: 'Total Charge Points',
      activeChargingSessions: 'Active Charging Sessions',
      recentActivities: 'Recent Activities',
      noActivities: 'No recent activities',
      lastUpdated: 'Last updated',
      updatedRealtime: 'Updated in real-time',
      status: {
        available: 'Available',
        inUse: 'In Use',
        maintenance: 'Maintenance',
        offline: 'Offline',
        active: 'Active',
        inactive: 'Inactive'
      },
      chargePointStatus: 'Charge Point Status',
      locationStatus: 'Location Status'
    }
  },
  chargePoints: {
    title: 'Charge Points',
    addChargePoint: 'Add Charge Point',
    editChargePoint: 'Edit Charge Point',
    setPassword: 'Set Password',
    copyUrl: 'Copy URL',
    urlDetails: 'URL Details',
    ipDomain: 'IP Domain',
    path: 'Path',
    authKey: 'Auth Key',
    noPassword: 'No Password',
    noPasswordHint: 'Leave blank to disable password',
    chargePointId: 'Charge Point ID',
    name: 'Name',
    location: 'Location',
    currentLocation: 'Current Location',
    searchLocation: 'Search for a location',
    searchAndSelectLocation: 'Search and select a location',
    searchLocationPlaceholder: 'Enter location name',
    typeToSearchLocations: 'Type to search locations',
    enterSearchTerms: 'Enter search terms',
    noLocationsFound: 'No location found',
    locationsFound: 'Locations found',
    vendor: 'Vendor',
    selectVendor: 'Select Vendor',
    model: 'Model',
    mode: {
      title: 'Mode',
      public: 'Public',
      private: 'Private'
    },
    vehicleType: {
      title: 'Vehicle Type',
      motorbike: 'Motorbike',
      car: 'Car',
      both: 'Both'
    },
    type: 'Type',
    power: 'Power (kW)',
    connector: 'Connector Type',
    price: 'Price',
    status: 'Status',
    connectors: 'Connectors',
    tableActions: 'Actions',
    selectLocation: 'Select a location',
    priceSchedules: 'Price Schedules',
    startTime: 'Start Time',
    endTime: 'End Time',
    addTimePrice: 'Add Time-based Price',
    remove: 'Remove',
    connectorId: 'Connector ID',
    addConnector: 'Add Connector',
    qrCode: {
      title: 'QR Code for Connector #{{number}}',
      download: 'Download QR',
      print: 'Print QR'
    },
    chargePointStatus: {
      available: 'Available',
      'in-use': 'In Use',
      maintenance: 'Maintenance',
      offline: 'Offline'
    },
    connectorStatus: {
      Available: 'Available',
      Preparing: 'Preparing',
      Charging: 'Charging',
      SuspendedEVSE: 'Suspended EVSE',
      SuspendedEV: 'Suspended EV',
      Finishing: 'Finishing',
      Reserved: 'Reserved',
      Unavailable: 'Unavailable',
      Faulted: 'Faulted'
    },
    connectorTypes: {
      Type1: 'Type 1',
      Type2: 'Type 2',
      CHAdeMO: 'CHAdeMO',
      CCS: 'CCS',
      CCS2: 'CCS2'
    },
    chargeTypes: {
      AC: 'AC',
      DC: 'DC'
    },
    controls: {
      restart: 'Restart',
      unlock: 'Unlock',
      lock: 'Lock'
    },
    password: {
      title: 'Password',
      set: 'Set Password',
      remove: 'Remove Password',
      current: 'Current Password',
      new: 'New Password',
      confirm: 'Confirm Password',
      manage: 'Manage Password'
    },
    confirmations: {
      delete: 'Are you sure you want to delete this charge point?',
      restart: 'Are you sure you want to restart this charge point?',
      unlock: 'Are you sure you want to unlock connector {{number}}?',
      lock: 'Are you sure you want to lock connector {{number}}?'
    },
    messages: {
      noLocation: 'No Location',
      noPrice: 'No price set',
      pricePerKwh: '/kWh',
      enterChargePointId: 'Enter unique charge point ID',
      noVendor: 'No Vendor',
      selectVendor: 'Select a vendor',
      vendorRequired: 'Please select a vendor',
      createSuccess: 'Charge point created successfully',
      updateSuccess: 'Charge point updated successfully',
      saveError: 'Failed to save charge point',
      enterNewPassword: 'Enter new password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      passwordOptional: 'This is optional, leave blank to keep current',
      leaveUnchanged: 'Leave unchanged',
      typeToSearch: 'Type to search'
    },
    search: 'Search for a charge point',
    allStatuses: 'All Statuses',
    allOperators: 'All Operators',
    allTypes: 'All Types',
    allVehicleTypes: 'All Vehicle Types'
  },
  rfidTags: {
    title: 'RFID Tags',
    addTag: 'Add New Tag',
    editTag: 'Edit RFID Tag',
    tagId: 'Tag ID',
    type: 'Type',
    user: 'User',
    status: 'Status',
    expiryDate: 'Expiry Date',
    lastUsed: 'Last Used',
    description: 'Description',
    assignUser: 'Assign to User',
    selectUser: 'Select a user',
    unassigned: 'Unassigned',
    never: 'Never',
    types: {
      personal: 'Personal',
      public: 'Public'
    },
    tagStatus: {
      active: 'Active',
      blocked: 'Blocked',
      expired: 'Expired'
    },
    actions: {
      block: 'Block',
      activate: 'Activate'
    },
    messages: {
      saveSuccess: 'RFID tag saved successfully',
      saveError: 'Failed to save RFID tag',
      deleteError: 'Failed to delete RFID tag',
      updateError: 'Failed to update tag status',
      fetchError: 'Failed to fetch RFID tags',
      usersFetchError: 'Failed to load users'
    }
  },
  transactions: {
    title: 'Charging Transactions',
    columns: {
      user: 'User',
      chargePoint: 'Charge Point ID:Connector',
      startTime: 'Start Time',
      endTime: 'End Time',
      energy: 'Energy (kWh)',
      fee: 'Fee',
      status: 'Status'
    },
    status: {
      active: 'active',
      suspended: 'suspended',
      completed: 'completed',
      failed: 'failed'
    },
    messages: {
      fetchError: 'Failed to fetch transactions',
      inProgress: 'In Progress',
      publicTag: 'Public Tag',
      unknownCharger: 'Unknown Charger',
      unknownTag: 'Unknown',
      noTransactions: 'No transactions found'
    },
    filters: {
      operator: 'Operator',
      status: 'Status',
      chargePoint: 'Charge Point',
      user: 'User',
      allStatuses: 'All Statuses',
      allOperators: 'All Operators',
      startDate: 'Start Date',
      endDate: 'End Date',
      reset: 'Reset'
    },
    totalCount: 'Showing {{showing}} of {{total}} total transactions',
    activeCount: 'Active transactions: {{count}}'
  },
  users: {
    title: 'Users',
    addUser: 'Add New User',
    editUser: 'Edit User',
    columns: {
      name: 'Name',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      createdAt: 'Created At',
      actions: 'Actions'
    },
    status: {
      active: 'active',
      inactive: 'inactive'
    },
    actions: {
      activate: 'Activate',
      deactivate: 'Deactivate',
      delete: 'Delete',
      edit: 'Edit'
    },
    messages: {
      fetchError: 'Failed to fetch users',
      deleteError: 'Failed to delete user',
      updateError: 'Failed to update user status',
      saving: 'Saving...',
      deleteConfirmation: 'Are you sure you want to delete this user? This action cannot be undone.',
      rfidTagsWarning: 'This user has the following RFID tags associated. Please remove these tags before deleting the user:',
      deleting: 'Deleting...'
    },
    modal: {
      passwordNote: '(leave blank to keep current)',
      form: {
        username: 'Username',
        email: 'Email',
        password: 'Password',
        name: 'Name',
        phone: 'Phone'
      }
    },
    rfidTags: {
      title: 'Associated RFID Tags',
      columns: {
        tagId: 'Tag ID',
        status: 'Status',
        expiryDate: 'Expiry Date',
        actions: 'Actions'
      },
      actions: {
        manage: 'Manage RFID Tags',
        close: 'Close'
      }
    }
  },
  layout: {
    title: 'EV Charging',
    navigation: {
      dashboard: 'Dashboard',
      operators: 'Operators',
      vendors: 'Vendors',
      locations: 'Locations',
      areas: 'Areas',
      chargePoints: 'Charge Points',
      transactions: 'Transactions',
      users: 'Users',
      rfidTags: 'RFID Tags',
      pendingImages: 'Pending Images',
      settings: 'Settings',
      notifications: 'Notifications',
      signOut: 'Sign Out'
    },
    actions: {
      signOut: 'Sign Out'
    },
    footer: {
      copyright: '© 2024 EV Charging Platform v1.0.2 - All rights reserved.'
    }
  },
  operators: {
    title: 'Operator Management',
    addOperator: 'Add Operator',
    editOperator: 'Update Operator',
    columns: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      status: 'Status',
      paymentType: 'Payment Type',
      createdAt: 'Created At',
      actions: 'Actions'
    },
    form: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      status: 'Status',
      paymentType: 'Payment Type',
      password: 'Password (optional)',
      googlePlayLink: 'Google Play Store Link',
      appStoreLink: 'App Store Link',
      appGalleryLink: 'AppGallery Link',
      statusOptions: {
        active: 'Active',
        inactive: 'Inactive'
      },
      paymentOptions: {
        prepaid: 'Prepaid',
        postpaid: 'Postpaid'
      }
    },
    actions: {
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel'
    },
    messages: {
      fetchError: 'Unable to fetch operators',
      createSuccess: 'Operator created successfully!',
      updateSuccess: 'Operator updated successfully!',
      deleteSuccess: 'Operator deleted successfully',
      deleteConfirm: 'Are you sure you want to delete this operator?',
      loginCredentials: 'Login credentials:\nEmail: {{email}}\nPassword: {{password}}',
      saving: 'Saving...'
    }
  },
  login: {
    title: {
      firstLogin: 'Create First Admin Account',
      normal: 'Welcome Back! Please Sign In'
    },
    version: 'v1.0.2',
    firstLoginMessage: 'This is the first login. Your account will be created with admin privileges.',
    form: {
      username: 'Username or Email',
      adminUsername: 'Admin username',
      password: 'Password'
    },
    actions: {
      createAdmin: 'Create Admin Account',
      signIn: 'Sign in',
      processing: 'Processing...'
    },
    errors: {
      invalidCredentials: 'Invalid credentials'
    }
  },
  vendors: {
    title: 'Charger Vendors',
    description: 'Manage charging station hardware vendors and their information.',
    addVendor: 'Add Vendor',
    editVendor: 'Edit Vendor',
    deleteConfirmation: 'Are you sure you want to delete this vendor?',
    table: {
      name: 'Vendor Name',
      website: 'Website',
      status: 'Status',
      actions: 'Actions',
    },
    modal: {
      addTitle: 'Add New Vendor',
      editTitle: 'Edit Vendor',
      name: 'Vendor Name',
      website: 'Website URL',
      description: 'Description',
      status: 'Status',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      saveChanges: 'Save Changes',
      add: 'Add Vendor',
      cancel: 'Cancel',
    },
    messages: {
      createSuccess: 'Vendor created successfully',
      updateSuccess: 'Vendor updated successfully',
      deleteSuccess: 'Vendor deleted successfully',
      saveError: 'Failed to save vendor',
      deleteError: 'Failed to delete vendor',
      fetchError: 'Failed to fetch vendors',
    },
  },
  wallet: {
    balance: 'Balance',
    topUp: 'Top Up',
    paymentMethods: {
      title: 'Payment Methods',
      momo: 'Momo',
      vnpay: 'VNPay',
      zalopay: 'ZaloPay',
      postpaid: 'Postpaid (Pay Later)',
      account: 'Account'
    },
  },
  areas: {
    title: 'Administrative Areas',
    addArea: 'Add Area',
    editArea: 'Edit Area',
    searchPlaceholder: 'Search areas...',
    root: 'Root',
    fields: {
      name: 'Name',
      type: 'Type',
      code: 'Code',
      status: 'Status',
      latitude: 'Latitude',
      longitude: 'Longitude'
    },
    types: {
      province: 'Province',
      city: 'City',
      district: 'District',
      ward: 'Ward'
    },
    status: {
      active: 'Active',
      inactive: 'Inactive'
    },
    messages: {
      deleteConfirm: 'Are you sure you want to delete this area?',
      createSuccess: 'Area created successfully',
      updateSuccess: 'Area updated successfully',
      deleteSuccess: 'Area deleted successfully',
      error: 'An error occurred'
    }
  },
  admin: {
    settings: 'Settings',
    notifications: 'Notifications',
    sendPushNotifications: 'Send Push Notifications',
    notificationType: 'Notification Type',
    notificationTypeHelp: 'Select the type of notification to send. Users will only receive notifications they have enabled in their preferences.',
    notificationTypes: {
      userMessaging: 'User Messaging',
      appUpdate: 'App Update',
      newStation: 'New Charging Station'
    },
    targetUsers: 'Target Users',
    targetTypes: {
      selected: 'Selected Users',
      role: 'Users by Role',
      all: 'All Users'
    },
    userRole: 'User Role',
    roles: {
      user: 'User',
      admin: 'Admin',
      operator: 'Operator'
    },
    selectUsers: 'Select Users',
    deselectAll: 'Deselect All',
    selectAll: 'Select All',
    noUsersWithPushTokens: 'No users with push tokens found',
    selectedUsers: '{{count}} users selected',
    notificationTitle: 'Notification Title',
    notificationTitlePlaceholder: 'Enter notification title',
    notificationMessage: 'Notification Message',
    notificationMessagePlaceholder: 'Enter notification message',
    imageUrl: 'Image URL',
    imageUrlHelp: 'An image to display with the notification (must be publicly accessible)',
    sendNotifications: 'Send Notifications'
  }
}; 